exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".microcart-products-list .product .prices span {\n  font-size: 0.8125rem;\n  font-weight: 400;\n  line-height: 1.313rem;\n  color: #000000;\n  font-style: italic;\n  font-family: freight-big-pro, Times, Times New Roman, Georgia, serif;\n}\n.microcart-products-list .product .quantity-select-action input[type='number'] {\n  padding: 0;\n  text-align: center;\n  border: none;\n}\n.microcart-products-list .product .quantity-select-action button {\n  border: none;\n  height: 26px;\n  width: 26px;\n  margin: 0 2px;\n  padding-top: 6px;\n}\n", ""]);

// exports
